import axios from "axios";
import { Constants } from "../utils/Constants";

export function getDashboard(params) {
    return axios.get(`${Constants.baseUrl}/dashboard`, { params });
}
